







import Vue from 'vue';
import Component from 'vue-class-component';
import { PageTitle } from '@questelservices/common-vue';
import FeeDesignationsGrid from '../components/fee-designations/fee-designations-grid.vue';

@Component({
  components: {
    PageTitle,
    FeeDesignationsGrid
  }
})
export default class FeeDesignations extends Vue {}
